"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var reactstrap_1 = require("reactstrap");
var pricing_1 = require("../../../api/pricing");
var subscription_1 = require("../../../api/subscription");
var EditServiceButton = function (props) {
    var className = props.className;
    var _a = react_1.useState({ id: "" }), graphData = _a[0], setGraphData = _a[1];
    var _b = react_1.useState(0), companyId = _b[0], setCompanyId = _b[1];
    var _c = react_1.useState(false), isLoaded = _c[0], setIsLoaded = _c[1];
    var _d = react_1.useState({ id: 0, name: "", companyId: "", serviceId: "" }), serviceData = _d[0], setServiceData = _d[1];
    var _e = react_1.useState(new Array()), serviceNameOptions = _e[0], setServiceNameOptions = _e[1];
    var _f = react_1.useState(""), selectedServiceId = _f[0], setSelectedServiceId = _f[1];
    var _g = react_1.useState(false), modal = _g[0], setModal = _g[1];
    var toggle = function () { return setModal(!modal); };
    var submitUpdateService = function () {
        var obj = {
            companyId: serviceData.companyId,
            purchasedServiceId: serviceData.id,
            serviceId: selectedServiceId,
            userId: graphData.id,
        };
        subscription_1.updatePurchasedService(props.id, obj).then(function (response) {
            props.modalCallback(serviceData.id, response.service.name);
        });
        toggle();
    };
    var onLoad = function () {
        if (props.id && companyId == 0) {
            setCompanyId(props.id);
        }
        if (props.userId && graphData.id == "") {
            setGraphData({ id: props.userId });
        }
        if (serviceData.id == 0 && props.list != null) {
            var result = props.list.reduce(function (acc, item) { if (props != null && props.id != null && props.id == item.id)
                acc = item; return acc; }, { id: 0 });
            setServiceData(result);
        }
        if (!isLoaded && serviceNameOptions.length === 0) {
            pricing_1.fetchServices().then(function (response) {
                var newList = response.list.map(function (item) {
                    var newItem = {
                        key: item.name,
                        value: item.serviceId,
                        label: item.name
                    };
                    return newItem;
                });
                setServiceNameOptions(__spreadArray([], newList));
                setIsLoaded(true);
            }).catch(console.error);
        }
    };
    //const setFormChange = (e: ChangeEvent<HTMLInputElement>, field: any) => {
    //    var newServiceData: any = serviceData;
    //    newServiceData[field] = e.target.value;
    //    console.log(newServiceData[field]);
    //    setServiceData({ ...newServiceData });
    //    console.log(serviceData);
    //};
    react_1.useEffect(function () {
        if (!isLoaded)
            onLoad();
    }, [serviceData, setServiceData, serviceNameOptions, setServiceNameOptions, isLoaded, setIsLoaded]);
    return (React.createElement("div", null,
        React.createElement(reactstrap_1.Button, { style: { padding: 0 }, color: "link", onClick: toggle },
            React.createElement("a", { className: "padding-default" },
                React.createElement("img", { src: "./edit.svg", className: "font-icon" }))),
        React.createElement(reactstrap_1.Modal, { isOpen: modal, toggle: toggle, className: className, size: "lg", centered: true },
            React.createElement(reactstrap_1.ModalHeader, { toggle: toggle }, "Edit Service"),
            React.createElement(reactstrap_1.ModalBody, null,
                React.createElement(reactstrap_1.Form, null,
                    React.createElement(reactstrap_1.Row, { form: true },
                        React.createElement(reactstrap_1.Col, { md: 12 },
                            React.createElement(reactstrap_1.FormGroup, null,
                                React.createElement(reactstrap_1.Label, { for: "Name" }, "Name"),
                                React.createElement(reactstrap_1.Input, { type: "select", name: "name", id: "name", onChange: function (e) { return setSelectedServiceId(e.target.value); } },
                                    React.createElement("option", { value: "", disabled: true, selected: true }, "Please select service"),
                                    serviceNameOptions.map(function (option) { return (React.createElement("option", { key: option.key, value: option.value }, option.label)); }))))))),
            React.createElement(reactstrap_1.ModalFooter, null,
                React.createElement(reactstrap_1.Button, { color: "primary", onClick: toggle }, "Cancel"),
                ' ',
                React.createElement(reactstrap_1.Button, { color: "secondary", onClick: function () { return submitUpdateService(); } }, "Confirm")))));
};
exports.default = EditServiceButton;
//# sourceMappingURL=EditServiceButton.js.map